export default __webpack_public_path__ + "static/media/instagram.b51d7bc3.svg";